import React from 'react';

import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import ActionButton from 'components/Buttons/ActionButton';
import { DetailsButtonIcon } from 'components/Icons';

interface DetailsButtonProps extends RouteComponentProps {
  linkUrl: string;
}

const DetailsButton: React.FC<DetailsButtonProps> = ({ linkUrl, location }) => {
  return (
    <ActionButton
      variant="outlined"
      icon={DetailsButtonIcon}
      component={Link}
      data-qa-id={'eye-button'}
      to={{ pathname: linkUrl, state: { referer: location.pathname } }}
    />
  );
};
export default withRouter(DetailsButton);
